// extracted by mini-css-extract-plugin
export default {"page":"styles_page__wTl8Q","content":"styles_content__4F6A2","main":"styles_main__3oant","mainInner":"styles_mainInner__vLKJM"};